module.exports = __webpack_public_path__ + "media/images/pt/connect_dots-c93dfe7a3858fa4dad689792195a30e3.png";